import { useIntl } from 'react-intl';
import { checkFeatureFlagGate } from 'src/utils/feature-flags/check-feature-flag';
import { featureFlags } from 'src/utils/feature-flags/feature-flag-manifest';

import { Picture } from '@/components/wpl/image/src/image';
import { useLocalizedHref } from '@/libraries/web-framework/src/localization/use-localized-href';
import { ProductPageNav } from '@/patterns/global-nav/src/product-page-nav';

export const RovoDevNav = () => {
	const intl = useIntl();

	const oldSignupLink = useLocalizedHref('/try/cloud/signup?bundle=devai');
	const newSignupLink = useLocalizedHref('/software/jira/dev');
	const pricingHref = useLocalizedHref('/software/rovo-dev/pricing');
	const documentationHref = useLocalizedHref(
		'https://support.atlassian.com/rovo/docs/work-with-rovo-dev-agents',
	);

	const logo = (
		<Picture
			image={{
				src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/d888ipg7v6w1c6x4xfb578gfiw5238d0.svg',
				alt: 'Rovo Dev',
			}}
			style={{ height: '26px' }}
		/>
	);

	let linkProps = [
		{
			globalLinksKey: 'pricing',
			linkText: intl.formatMessage({
				id: 'RovoDevNav.pricing',
				defaultMessage: 'Pricing',
			}),
			hasDropdown: false,
			productKey: 'rovoDev',
			href: pricingHref,
		},
		{
			globalLinksKey: 'documentation',
			linkText: intl.formatMessage({
				id: 'RovoDevNav.documentation',
				defaultMessage: 'Documentation',
			}),
			hasDropdown: false,
			productKey: 'rovoDev',
			href: documentationHref,
		},
	];

	const oldCtaText = intl.formatMessage({
		id: 'RovoDevNav.tryItFree',
		defaultMessage: 'Try it Free',
	});
	const newCtaText = intl.formatMessage({
		id: 'RovoDevNav.tryJira',
		defaultMessage: 'Try Jira',
	});

	const isEol = checkFeatureFlagGate(featureFlags.rovoDevEolProductNav);
	if (isEol) {
		linkProps = linkProps.filter((link) => link.globalLinksKey !== 'pricing');
	}
	const signupLink = isEol ? newSignupLink : oldSignupLink;
	const ctaText = isEol ? newCtaText : oldCtaText;

	return (
		<ProductPageNav
			productLogoUrl="/software/rovo-dev"
			productLogo={logo}
			productLogoAriaLabel={intl.formatMessage({
				id: 'RovoDevNav.productLogoAriaLabel',
				defaultMessage: 'Rovo Dev logo',
			})}
			mobileCtaText={ctaText}
			navigationTrynowCtaText={ctaText}
			mobileCtaUrl={signupLink}
			mobileLogo={logo}
			productPageNavLinks={linkProps}
			navigationTrynowCtaUrl={signupLink}
			mobileLinksSections={[
				{
					mobileLinkKey: 'mobile-rovo-dev',
					mobileLinksProps: linkProps,
				},
			]}
		/>
	);
};
